/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { QualityRecordBase } from "../../../../schema/generated/QualityRecord";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class QualityRecordDataApi extends EntityDataApi<QualityRecordBase> {
  public readonly def = idbEntityDefs.QualityRecord;
}